import React, { useEffect, useState } from 'react';
import { accessService } from '../services/access.service';
import './AccessBanner.css';

/**
 * Bandeau « il vous reste X jours » (chantier 3A). Affiché en haut du back-office
 * quand l'accès est 'full' mais approche de la fin (≤ 14 jours). Discret, informatif.
 * Au-delà du seuil ou en cas d'erreur, rien n'est affiché.
 *
 * JAMAIS pour un abonnement `active`. Sur un compte payant, `free_until` porte
 * la fin de la PÉRIODE DE FACTURATION — 14 jours pendant l'essai, ~30 ensuite —
 * et Stripe la reconduit tout seul. Sans cette exclusion, le client qui vient
 * de saisir sa carte lisait « il vous reste 13 jours, contactez-nous » : une
 * alerte à l'action pour un renouvellement automatique. Un impayé, lui, fait
 * passer le statut à `past_due` et le bandeau réapparaît à juste titre.
 *
 * Le `catch` silencieux n'est PAS un fallback ouvert : ce composant n'autorise
 * rien, il informe. Ne rien afficher quand on ne sait pas combien de jours
 * restent est le comportement correct — c'est `AccessGate` qui garde l'accès,
 * et lui échoue fermé.
 */
const THRESHOLD_DAYS = 14;
// Même valeur que `SUBSCRIPTION_ACTIVE` côté API (usecase/access.py).
const SUBSCRIPTION_ACTIVE = 'active';

const AccessBanner: React.FC = () => {
  const [daysLeft, setDaysLeft] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    accessService
      .getState()
      .then((s) => {
        if (cancelled) return;
        if (
          s.access === 'full' &&
          s.status !== SUBSCRIPTION_ACTIVE &&
          s.free_until &&
          s.days_left <= THRESHOLD_DAYS
        ) {
          setDaysLeft(s.days_left);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (daysLeft === null) return null;

  return (
    <div className="access-banner">
      Il vous reste <strong>{daysLeft} jour{daysLeft > 1 ? 's' : ''}</strong> d&apos;accès.
      Pour continuer sans interruption, contactez-nous à{' '}
      <a href="mailto:contact@coloc.app">contact@coloc.app</a>.
    </div>
  );
};

export default AccessBanner;
